import Head from 'next/head';
import getConfig from 'next/config';
const { publicRuntimeConfig } = getConfig();

interface Props {
  hideDefaultCanonical: boolean;
  applyV2Styles: boolean;
  canonicalUrl: string;
}

const HeaderLinks = ({ hideDefaultCanonical, canonicalUrl }: Props) => (
  <Head>
    <link
      rel="shortcut icon"
      href="https://assets1.cleartax-cdn.com/cleartax/images/1644906212_clearfavicon.png"
      type="image/png"
    />

    {/* this file adds the font-display property to each font-face which google font does not */}
    <link href="/save/static/font.css" rel="stylesheet" type="text/css" />
    <link
      href="https://assets1.cleartax-cdn.com/clearsave/css/bundle.736ed2.css"
      rel="stylesheet"
      type="text/css"
    />
    {!hideDefaultCanonical ? (
      <link rel="canonical" href={canonicalUrl || 'https://cleartax.in/save'} />
    ) : null}
    <link
      rel="stylesheet"
      href={`${publicRuntimeConfig.staticFolder}/_next/static/style.css`}
    />
    <link
      type="text/css"
      rel="stylesheet"
      href="https://assets1.cleartax-cdn.com/cleartax/images/1634818867_lilgiant.css"
      media="screen"
    />
  </Head>
);

export default HeaderLinks;



// WEBPACK FOOTER //
// ./components/header/headerLinks.tsx